












import { defineComponent } from '@nuxtjs/composition-api';
import { UCIcon } from '@shared/ui';

export default defineComponent({
  name: 'StoreLocatorHeader',
  components: {
    UCIcon,
  },
});
